import api from 'services/inventory/maintenance-schedule'

export const handleSave = async (values: any) => {
  let res = await api.addHoursAction(values)

  return res?.data?.success
}
